module.exports = __webpack_public_path__ + "img/viber.165e6b37.svg";